import React from "react";
import { Box, Typography } from "@mui/material";
import Field from "../shared/Field";
import ImageUploadField from "../../../../components/ImageUploadField";

const FormStats = ({ data, onChange }) => {
  const updateStat = (i, field, value) => {
    const items = [...data.items];
    items[i] = { ...items[i], [field]: value };
    onChange({ ...data, items });
  };

  return (
    <Box>
      <ImageUploadField
        label="Illustration Image (left side)"
        value={data.imageUrl}
        onChange={(v) => onChange({ ...data, imageUrl: v })}
        hint="The illustration shown on the left"
      />
      {data.items.map((stat, i) => (
        <Box
          key={i}
          mb={2}
          p={2}
          sx={{
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: "10px",
            background: "rgba(255,255,255,0.03)",
          }}
        >
          <Typography
            variant="caption"
            color="text.secondary"
            fontWeight={600}
            display="block"
            mb={1.5}
          >
            Stat {i + 1}
          </Typography>
          <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
            <Field
              label="Value"
              value={stat.value}
              onChange={(v) => updateStat(i, "value", v)}
              placeholder="0+"
            />
            <Field
              label="Label"
              value={stat.label}
              onChange={(v) => updateStat(i, "label", v)}
              placeholder="Years of Excellence"
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default FormStats;
